import classNames from 'classnames';

import { useTranslate } from '../../../../i18n/useTranslationModules';
import { LanguagesAbbr, Speaker } from '../../../../types/working-model';
import { getTextValue } from '../../../../utils/utils';
import { renderSocialLinks } from '../../../general-ui/social-links/social-links';
import { TypographyItem } from '../../../general-ui/typography-item/typography-item';
import useTranslationRoute from '../../hooks/use-translation-route';
import { stylingOverrideReturns } from '../../utils';

interface SpeakerCardProps {
	speaker: Speaker;
	language: LanguagesAbbr;
	stylingOverrides: stylingOverrideReturns;
	template: string;
	onClick: (speaker: Speaker) => void;
	isLandingPage?: boolean;
}
const SpeakerCard: React.FC<SpeakerCardProps> = ({
	speaker,
	language,
	stylingOverrides,
	onClick
}) => {
	const {
		moduleTitleOverrides,
		moduleDescriptionOverrides,
		primaryButtonOverrides,
	} = stylingOverrides;
	const socialLinks = speaker.link_social ? renderSocialLinks(speaker.social_links || [], primaryButtonOverrides) : null;
	const { description } = getTextValue(speaker, language);
	const translationRoute = useTranslationRoute();
	const { t } = useTranslate(translationRoute);
	const id = speaker.module_id;

	return (
		<li className="speakers-column">
			<div className="speaker" onClick={() => onClick(speaker)}>
				<img src={speaker.image} alt={speaker.first_name} />
				<div className="speaker-name-container">
					<TypographyItem
						className={classNames('speaker-name', moduleTitleOverrides)}
						tagName="h3"
						aria-label={`${t(`speakers.${id}.first_name`, speaker.first_name)} ${t(`speakers.${id}.last_name`, speaker.last_name)}`}
					>
						{t(`speakers.${id}.first_name`, speaker.first_name)} {t(`speakers.${id}.last_name`, speaker.last_name)}
					</TypographyItem>
					<TypographyItem
						className={classNames('speaker-job-title', moduleTitleOverrides)}
						tagName="h5"
					>
						{t(`speakers.${id}.job_title`, speaker.job_title?.[language] as string ?? speaker.job_title?.base ?? '')}
					</TypographyItem>
					<TypographyItem className={classNames('evt-body-text-2 speaker-about', moduleDescriptionOverrides)} tagName="p">
						{t(`speakers.${id}.description`, description)}
					</TypographyItem>
					{socialLinks}
				</div>
			</div>
		</li>
	);
};

export default SpeakerCard;
